<template>
  <vue-tags-input
    ref="tagsInput"
    v-model="text"
    :tags="modelValue"
    :add-on-key="[13, 32, ',']"
    :allow-edit-tags="true"
    @tags-changed="(newTags) => $emit('update:modelValue', newTags)"
  />
</template>

<script>
import VueTagsInput from '@sipec/vue3-tags-input';

export default {
  components: { VueTagsInput },
  props: {
    modelValue: {
      type: Array,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return { text: '' };
  },
  methods: {
    async createTagFromInput() {
      const inputField = this.$refs.tagsInput.$el?.querySelector('input');
      if (inputField && this.text.trim()) {
        await inputField.dispatchEvent(new KeyboardEvent('keydown', { keyCode: 32 }));
      }
    },
  },
  expose: ['createTagFromInput'],
};
</script>

<style lang="scss" scoped>
 .vue-tags-input::v-deep {
    @apply w-full max-w-none;
    .ti-input {
      @apply rounded-md;
    }

    .ti-tag {
      @apply rounded-md text-purple-500 bg-purple-100;
    }

    .ti-deletion-mark, .ti-invalid, .ti-duplicate {
      @apply text-white;
    }
  }
</style>
